"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_1 = require("../../node");
const torch_data_defs_1 = require("torch-data-defs");
const aggregate_types_1 = require("../../../common/aggregate-types");
const signature_1 = require("../../signature");
class PophealthNode extends node_1.default {
    static from(obj) {
        if (obj['type'] === 'pophealth')
            return new PophealthNode(obj['dataset'], obj['columns'], obj['geography']);
        return null;
    }
    constructor(dataset, columns, geography) {
        super('Pophealth Node');
        this.dataset = dataset;
        this.columns = columns;
        this.geography = geography;
    }
    checkPort() {
        return false;
    }
    getSignature(datasetRepo) {
        let signature = new signature_1.default();
        signature.columns = this.columns
            .map(c => c[1])
            .concat([this.geography])
            .map(c => new signature_1.ColumnSignature(c, this.id));
        let resolvedGeo = torch_data_defs_1.default.resolveField('zip-geo:' + this.geography, 'zip-geo', datasetRepo.datasetByName);
        signature.grains = [new signature_1.GrainSignature(resolvedGeo[0], resolvedGeo[1])];
        return signature;
    }
    validate(datasetRepo) {
        let possibleAggTypes = Object.values(aggregate_types_1.Aggregation);
        let aggValid = this.columns.every(c => possibleAggTypes.includes(c[0]));
        let datasetDef = datasetRepo.datasetByName[this.dataset];
        let geo = 'zip-geo:' + this.geography;
        let geographyValid = datasetDef.grain.includes(geo) || (!!datasetDef.joins && datasetDef.joins.includes(geo));
        return aggValid && geographyValid;
    }
    serialize() {
        return super.serialize({
            type: 'pophealth',
            dataset: this.dataset,
            columns: this.columns,
            geography: this.geography,
        });
    }
}
exports.default = PophealthNode;
